import PropTypes from 'prop-types';

import { Row, Col, FormGroup } from 'twyne-new.ui';

import Input from 'components/form/Input';

import List from './List'

const propTypes = {
  offers: PropTypes.array,
  offerOptions: PropTypes.array,
  onChange: PropTypes.func,
};

export default function SelectOffer({ offers, offerOptions, onChange }) {
  const value = offers?.length ? offers[0].id : null

  const handleChange = offerValues => {
    onChange(offerValues)
  }

  return <Row id="select-offer">
    <Col size="12" >
      <FormGroup>
        <List data={offers} options={offerOptions} onChange={handleChange} />
        <Input required name="_" type="hidden" value={value} />
      </FormGroup>
    </Col>
  </Row>
}

SelectOffer.propTypes = propTypes
SelectOffer.defaultProps = {}
